import type { DrillLocation } from '../../types/exploration';
import { reasonLabelForVolume } from '../sidebar/focusedReasonHelpers';
import { secondaryBucketKey } from '../secondaryGrouping';
import { volumeStatusLabel } from '../sidebar/volumeStatusLabel';
import type { GroupingModel } from './types';
import {
  volumeAccountKey,
  volumePassedThroughInstance,
  withVolumeStatusOverlay,
} from './groupingPathShared';

export const regionGrouping: GroupingModel = {
  secondary: 'region',

  locationForVolume(volume, opts) {
    const account = opts.groupByAccount ? volumeAccountKey(volume) : undefined;
    const region = secondaryBucketKey(volume, 'region', opts.tagKey);
    const structural: DrillLocation['structural'] = volumePassedThroughInstance(
      opts.currentLocation,
      volume
    )
      ? { kind: 'region', region, instanceId: volume.instanceId! }
      : { kind: 'region', region };

    return withVolumeStatusOverlay({ account, structural }, volume, opts.view);
  },

  locationForInstance(anchor, instanceId, opts) {
    if (!instanceId) return null;
    const account = opts.groupByAccount ? volumeAccountKey(anchor) : undefined;
    const region = secondaryBucketKey(anchor, 'region', opts.tagKey);
    return { account, structural: { kind: 'region', region, instanceId } };
  },

  scopeForLocation(volumes, location, opts) {
    let vols = volumes;
    if (location.account) vols = vols.filter((v) => volumeAccountKey(v) === location.account);

    const s = location.structural;
    if (s.kind === 'region') {
      if (s.region) vols = vols.filter((v) => (v.region || '(unknown)') === s.region);
      if (s.instanceId) vols = vols.filter((v) => (v.instanceId || '(no instance)') === s.instanceId);
    }

    if (location.statusLabel) {
      vols = vols.filter((v) => volumeStatusLabel(v, opts.view) === location.statusLabel);
    }
    if (location.focusedActivationKey) {
      vols = vols.filter((v) => v.activationStatus === location.focusedActivationKey);
    }
    if (location.reasonLabel) {
      vols = location.focusedActivationKey
        ? vols.filter(
            (v) => reasonLabelForVolume(v, location.focusedActivationKey!) === location.reasonLabel
          )
        : vols.filter((v) => v.supportLabel === location.reasonLabel);
    }

    return vols;
  },
};
